import * as ACT from '../actions/posActions';

export function pos(state = {}, action) {
    switch (action.type) {


        case ACT.POS_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.POS_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.POS_USER_ID:
            return {
                ...state,
                posUserId: action.data,
            };

        case ACT.POS_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.POS_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
